import { useState, useEffect } from 'react';

import config from '../../config';

const usePageVisibility = () => {
  const [isPageVisible, setIsPageVisible] = useState(!document.hidden);
  const [blurTimestamp, setBlurTimestamp] = useState<number>(Date.now());
  const [awayTooLong, setAwayTooLong] = useState<number>(0); //# of times the focus was away for too long

  //this gets called on every render, so removing the EventListeners via the
  //return function is important
  useEffect(() => {
    const handleVisibility = () => {
      setIsPageVisible(!document.hidden);
    };
    const handleBlur = () => {
      setBlurTimestamp(Date.now());
    };
    //if the window focus was gone for too long, increment awayTooLong variable
    const handleFocus = () => {
      const awaySeconds = (Date.now() - blurTimestamp) / 1000;
      if (awaySeconds > config.focusAwayTimeout) {
        setAwayTooLong(awayTooLong + 1);
      }
    };

    //this is for switching tabs
    document.addEventListener('visibilitychange', handleVisibility);
    //this is for user clicking somewhere outside the browser window
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, [blurTimestamp, awayTooLong]);

  return { isPageVisible, awayTooLong };
};

export default usePageVisibility;
